import React from "react"
import NavBar from "../Components/Navb"
import Footer from '../Components/Footer';

const Shipping=()=>{
   return (
      <>
       
     <NavBar/>
    <div style={{width:'100vw',height:'30vh',display:'flex',justifyContent:'center',alignItems:'center',fontFamily:'Arvo'}}>
       Shipping is not applicable for business.
    </div>
    <Footer/>
    </>
   )
}

export default Shipping